<template>
  <nut-overlay v-model:visible="store.getLoading"
               :close-on-click-overlay="false"
               :lock-scroll="true">
    <div class="loading">
      <Loading size="500px"
               color="#fff" />
    </div>
  </nut-overlay>

  <router-view v-slot="{ Component }">
    <keep-alive :include="keepAliveStore.cachedNames">
      <component :is="Component"></component>
    </keep-alive>
  </router-view>
  <div id="main-container"></div>
</template>

<script setup>
import { Loading } from '@nutui/icons-vue'

import { useLoadingStore } from '@/store/loading'
import { useKeepAliveStore } from '@/store/keep-alive'
const store = useLoadingStore()
const keepAliveStore = useKeepAliveStore()

</script>
<style lang="scss">
body {
  display: block !important;
  padding-bottom: constant(safe-area-inset-bottom); /* 兼容 iOS < 11.2 */
  padding-bottom: env(safe-area-inset-bottom); /* 兼容 iOS >= 11.2 */
}
#app {
  // width: 100vw;
  max-width: 1000px;
  margin: 0 auto;
  overflow: hidden;
}
* {
  -webkit-tap-highlight-color: transparent !important;
}
// 主题颜色修改
:root {
  --nut-primary-color: #007296;
  --nut-primary-color-end: #007296;
  --nut-tabs-horizontal-titles-item-min-width: 70px;
}
.loading {
  position: absolute;
  left: 50%;
  top: 50%;
}
#main-container {
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 10000;
  display: none;
}
</style>
